import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import OfferFlipCountdownBanner from "./OfferCountdownBanner";
import { discount } from "./apipath";

export default function GlobalCampaignBanner() {
  const { pathname } = useLocation();

  // ✅ hooks 一律先宣告
  const [data, setData] = useState(null);

  const isAdmin = pathname.startsWith("/adm");

  useEffect(() => {
    // ✅ 後台不打 API
    if (isAdmin) return;

    let mounted = true;

    axios
      .get(`${discount}campaign-active`)
      .then((res) => mounted && setData(res.data))
      .catch(() => mounted && setData({ enabled: false }));

    return () => {
      mounted = false;
    };
  }, [isAdmin]);

  // ✅ hooks 都跑完後，才做條件 return
  if (isAdmin) return null;
  if (!data?.enabled) return null;

  return (
    <OfferFlipCountdownBanner
      endAt={data.end_at}
      title={data.title}
      subtitle={data.subtitle}
      discounts={data.discounts || []}
      ctaText="立即選購"
      ctaHref="/quickbuy"
      allowClose={true}
      showDemoControls={false}
    />
  );
}
